import { useState } from 'react';
import {
  Box, TextField, Button, ToggleButton, ToggleButtonGroup,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { createNewPlayer, createNewGuest } from 'redux/slices';

export function AddPlayer({ isGuestList = false }) {
  const [playerName, setPlayerName] = useState('');
  const [gender, setGender] = useState('M');
  const players = useSelector((state) => state.players);

  const dispatch = useDispatch();

  const handleGenderChange = (event, newGender) => {
    if (newGender !== null) {
      setGender(newGender);
    }
  };

  const handleForm = (e) => {
    e.preventDefault();
    if (!playerName) return alert('Preencha o nome do jogador');
    const findPlayer = players.find((player) => player.playerName === playerName);
    if (findPlayer) return alert('Jogador já cadastrado');
    const initialPoints = prompt('Pontos iniciais do jogador (0-100)');
    const newPlayer = {
      playerId: players.length ? players[players.length - 1].playerId + 1 : 1,
      playerName,
      totalPoints: Math.min(100, Math.max(0, Number(initialPoints) || 0)),
      gender,
    };
    setPlayerName('');
    if (isGuestList) {
      dispatch(createNewGuest({ playerId: newPlayer.playerId, playerName }));
    }
    return dispatch(createNewPlayer(newPlayer));
  };

  return (
    <form onSubmit={handleForm}>
      <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
        <TextField
          size="small"
          value={playerName}
          onChange={(e) => setPlayerName(e.target.value)}
          id="player"
          label="Nome do jogador"
        />
        <ToggleButtonGroup
          value={gender}
          exclusive
          onChange={handleGenderChange}
          size="small"
        >
          <ToggleButton value="M">M</ToggleButton>
          <ToggleButton value="F">F</ToggleButton>
        </ToggleButtonGroup>
        <Button variant="contained" onClick={handleForm}>ADD</Button>
      </Box>
    </form>
  );
}
